import {getQuoteCarRelation} from '@api/quote'
import {getGlobalOptions} from '@api/common'

export default {
  data(){
    return{
      carRelationList:[],
      carYearRelationList:[],
    }
  },
  methods:{
    async handleCarRelation(){
      let form = this.formData.form11||{}
      let  {rgtn_yr,model_id,brand_id} = form||{}
      if(!brand_id||!model_id||!rgtn_yr)return
      let {data} = await getQuoteCarRelation({rgtn_yr,model_id,brand_id,hideLoading:true})
      this.carRelationList = data
    },
    async handleCarYearRelation(){
      let form = this.formData.form11||{}
      let  {rgtn_yr,model_id,brand_id} = form||{}
      if(!brand_id||!model_id)return
      let {data} = await getQuoteCarRelation({model_id,brand_id,hideLoading:true})
      this.carYearRelationList = data
    },
    async getCarRelation(){
      let  {rgtn_yr,model_id,brand_id} = this.formData||{}
      if(!brand_id||!model_id||!rgtn_yr||this.classId!=11)return
      let {data} = await getQuoteCarRelation({rgtn_yr,model_id,brand_id,hideLoading:true})
      this.carRelationList = data
    },
    async getCarYearRelation(){
      let  {rgtn_yr,model_id,brand_id} = this.formData||{}
      if(!brand_id||!model_id||this.classId!=11)return
      let {data} = await getQuoteCarRelation({model_id,brand_id,hideLoading:true})
      this.carYearRelationList = data
    },
  }
}
